import React from "react";
import logo from "../../assets/evacassets/image/logo.png";
import { useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Footer = () => {
  const nav = useNavigate();

  return (
    <footer className="bg-white border-top py-5" style={{ minHeight: "280px" }}>
      <br />
      <br />
      <div className="custom-container">
        {/* Top Row */}
        <div className="row align-items-center">
          {/* Left Menu */}
          <div className="col-md-6 d-flex flex-wrap gap-4 mb-3 mb-md-0 justify-content-center justify-content-md-start">
            <span
              className="text-dark fw-normal cursor-pointer"
              onClick={() => nav("/NewAbout")}
            >
              About us
            </span>
            <span
              className="text-dark fw-normal cursor-pointer"
              onClick={() => nav("/landing")}
            >
              Products
            </span>
            <span
              className="text-dark fw-normal cursor-pointer"
              onClick={() => nav("/evacsupport")}
            >
              Contact Us
            </span>
            {/* <span
              className="text-dark fw-normal cursor-pointer"
              onClick={() => nav("/books")}
            >
              Books
            </span> */}
          </div>

          {/* Social Icons */}
          <div className="col-md-6 d-flex justify-content-center justify-content-md-end gap-4">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook-f text-dark fs-5"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <i className="fab fa-linkedin-in text-dark fs-5"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram text-dark fs-5"></i>
            </a>
          </div>
        </div>
        <br />
        <br />
        {/* Divider */}
        <hr className="my-3" />
        <br />

        {/* Bottom Row */}
        <div className="row text-center text-md-start">
          {/* Left Copy */}
          <div className="col-12 col-md-4 mb-3 mb-md-0 text-muted small d-flex justify-content-center justify-content-md-start">
            © Copyright 2025, All Rights Reserved
          </div>

          {/* Center Logo */}
          <div className="col-12 col-md-4 mb-3 mb-md-0 d-flex justify-content-center">
            <img src={logo} alt="Pyramid Logo" style={{ height: "45px" }} />
          </div>

          {/* Right Legal Links */}
          <div className="col-12 col-md-4 d-flex flex-wrap gap-3 justify-content-center justify-content-md-end small">
            <span
              className="text-dark cursor-pointer"
              onClick={() => nav("/TermAndCondition")}
            >
              Terms of Service
            </span>
            <span
              className="text-dark cursor-pointer"
              onClick={() => nav("/PrivacyPolicy")}
            >
              Privacy Policy
            </span>
            <span
              className="text-dark cursor-pointer"
              onClick={() => nav("/FAQ")}
            >
              FAQ
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
